import React, { useState, useEffect, createContext } from "react";
import { connect } from "react-redux";

import * as UserActions from "../../middleware/Store/Actions/UserActions";

import LogService from "../../middleware/CommonSdk/LogService";
const LOG_TAG = "THEME";

export const themes = {
    dark: "dark",
    light: "light"
};

export const ThemeContext = createContext({
    theme: "",
    changeTheme: () => { },
});

const ThemeContextWrapper = props => {
    const [theme, setTheme] = useState();
    //light, dark...

    function changeTheme(theme) {
        LogService.trace(LOG_TAG, "CHANGE theme:" + theme);
        sessionStorage.setItem("theme", theme);
        props.updateTheme(theme);
        setTheme(theme);
    }

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect DidMount");

        const localStorageSaved = sessionStorage.getItem("theme");
        const saved = (props.customUserData && props.customUserData.customData && props.customUserData.customData.theme) ? props.customUserData.props.customUserData.customData.ThemePreferences : null;

        if (saved === null) {
            if (localStorageSaved === null) {
                setTheme(themes.light)
            } else {
                setTheme(localStorageSaved)
            }
        } else {
            setTheme(saved)
        }
    }, []);

    useEffect(() => {
        switch (theme) {
            case themes.light:
                document.body.classList.remove("dark");
                break;
            case themes.dark:
            default:
                document.body.classList.add("dark");
                break;
        }
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme: theme, changeTheme: changeTheme }}>
            {props.children}
        </ThemeContext.Provider>
    );
}

const mapStateToProps = state => {
    return {
        customUserData: state.user.customUserData
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateTheme: (theme) => dispatch(UserActions.updateThemePreferences(theme))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeContextWrapper);
